import { toaster } from "@/components/ui/toaster";
import { AppRoutes } from "@/constants/routes";
import {
  CreateServiceBody,
  ServiceDosisUnity,
  createService,
} from "@/services/service-master.service";
import { formatCurrencyInputToNumber } from "@/utils/query-string";
import { handlePermissionError } from "@/utils/permission-check";
import { NavigateFunction } from "react-router-dom";
import {
  getSelectedValue,
  getServiceMasterErrorMessage,
  isDosisUnidad,
  parseDecimalInput,
} from "../../utils/service-master-form";
import { ServiceMasterCreationForm } from "./service-master-creation.schema";

interface CreateServiceHandlerProps {
  values: ServiceMasterCreationForm;
  setLoadingCreate: (loading: boolean) => void;
  navigate: NavigateFunction;
  fetchPermissions: () => Promise<void>;
}

export const createServiceHandler = async ({
  values,
  setLoadingCreate,
  navigate,
  fetchPermissions,
}: CreateServiceHandlerProps) => {
  const isDosis = isDosisUnidad(values?.unidadCotizacion);

  const cotizacionesDosis: ServiceDosisUnity[] = isDosis
    ? (values?.cotizacionesDosis ?? []).map((row) => ({
        modalidad: Number(getSelectedValue(row?.modalidad)),
        dosisDesde: parseDecimalInput(row?.dosisDesde) ?? 0,
        dosisHasta: parseDecimalInput(row?.dosisHasta) ?? 0,
        valorUnitario: formatCurrencyInputToNumber(row?.valorUnitario ?? ""),
      }))
    : [];

  const body: CreateServiceBody = {
    titulo: String(values?.titulo ?? "").trim(),
    descripcion: String(values?.descripcion ?? "").trim(),
    valorUnitario: isDosis
      ? 0
      : formatCurrencyInputToNumber(values?.valorUnitario ?? ""),
    categoria: Number(getSelectedValue(values?.categoria)),
    unidadCotizacion: Number(getSelectedValue(values?.unidadCotizacion)),
    cotizacionesDosis,
  };

  setLoadingCreate(true);
  try {
    await createService(body);

    toaster.create({
      type: "success",
      title: "Servicio agregado exitosamente",
    });

    navigate(AppRoutes.SERVICES);
  } catch (error) {
    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
      AppRoutes.SERVICES,
    );

    if (!handled) {
      toaster.create({
        type: "error",
        title: getServiceMasterErrorMessage(
          error,
          "No se ha podido agregar el servicio.",
        ),
      });
    }

    throw error;
  } finally {
    setLoadingCreate(false);
  }
};
